// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"d7b04abb","171":"4aafd12b","453":"e4294bc7"}[chunkId] + ".chunk.js";
};